import { render } from "./Advice4.vue?vue&type=template&id=5d9b3282&scoped=true"
import script from "./Advice4.vue?vue&type=script&lang=js"
export * from "./Advice4.vue?vue&type=script&lang=js"

import "./Advice4.vue?vue&type=style&index=0&id=5d9b3282&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9b3282"]])

export default __exports__